module.exports = __webpack_public_path__ + "static/media/main.9d940108.png";